{
    "button": "Einstellungen",
    "group_my_account": "Mein Konto",
    "group_organisation": "Organisation",
    "language_label": "Sprache",
    "default_metric_label": "Kennzahl",
    "default_metric_description": "Die Kennzahl, die in Plato standardmäßig verwendet wird.",
    "metric_revenue": "Umsatz",
    "metric_order_sum": "Auftragseingang",
    "default_timeframe_label": "Zeitraum",
    "default_timeframe_description": "Der Zeitraum, der in Plato standardmäßig verwendet wird.",
    "timeframe_ytd": "Laufendes Jahr",
    "timeframe_ttm": "Letzte 12 Monate"
}
